import React from "react";
import { Link } from "@/components/common/Link";
export default function TheLiteraryPulse() {
  return <section data-section-id="225021" id="ozgecmis-ozet" className="bg-[#090909] text-[#f4efe5]">
      <div className="mx-auto grid max-w-[1320px] gap-9 px-5 py-14 sm:px-8 md:py-20 lg:grid-cols-[minmax(0,0.34fr)_minmax(0,0.66fr)] lg:gap-14 lg:px-10 lg:py-24">
        <div className="min-w-0 border-t border-[#f4efe5]/16 pt-8 lg:sticky lg:top-28 lg:self-start">
          <h2 className="font-serif text-[clamp(2.7rem,5.2vw,5.35rem)] font-normal leading-[0.96] tracking-[-0.03em] text-[#f4efe5]">
            Kurucumuz
          </h2>
        </div>

        <div className="min-w-0 border-t border-[#f4efe5]/14 pt-8 lg:pt-10">
          <h3 className="font-serif text-[clamp(2rem,3.8vw,4.05rem)] font-normal leading-[0.98] tracking-[-0.025em] text-[#f4efe5] break-words">
            Av. Raci Çetin Yüksekbaş
          </h3>

          <div className="mt-8 border-t border-[#f4efe5]/12 pt-6">
            <p className="font-sans text-base leading-relaxed text-[#f4efe5]/76 sm:text-lg">
              Yüksekbaş Hukuk ve Danışmanlık, Av. Raci Çetin Yüksekbaş tarafından kurulmuştur. Kurucumuzun öğrenim bilgileri ve mesleki özgeçmişi hakkında ayrıntılı bilgiye{" "}
              <Link to="/FounderAttorneyPage" className="text-[#f4efe5] underline decoration-[#f4efe5]/40 underline-offset-4 transition-colors hover:decoration-[#f4efe5]">
                Kurucumuz sayfasından
              </Link>{" "}
              ulaşılabilir.
            </p>
          </div>
        </div>
      </div>
    </section>;
}